// @core/api/endpoints/userprofile/create_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AvatarResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Create a new avatar
 * Uploads and creates a new avatar image for a profile. Multiple avatars can be stored, and one can be set as active.
 */
export async function CreateAvatar(
  file: File,
  options?: RequestOptions
): Promise<AvatarResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/avatars`;
  const requestOptions = options;
  const formData = new FormData();
  formData.append('file', file);
  return client.post<AvatarResponse>(requestPath, formData, requestOptions);
}
